import card from "../../assets/icons_components/card.svg";
import icon from "../../assets/icon.svg";
import accordions from "../../assets/icons_components/accordions.svg";
import badge from "../../assets/icons_components/badge.svg";
import buttons from "../../assets/icons_components/buttons.svg";
import carousel from "../../assets/icons_components/carousel.svg";
import fonts from "../../assets/icons_components/fonts.svg";
import footers from "../../assets/icons_components/footers.svg";
import images from "../../assets/icons_components/images.svg";
import lists from "../../assets/icons_components/lists.svg";
import modals from "../../assets/icons_components/modals.svg";
import { Link, useLocation } from "wouter";
import { useState } from "react";

const GitHubIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
		<path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v 3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
	</svg>
);



const LinkedInIcon = () => (
	<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
		<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.731-2.004 1.431-.103.25-.129.599-.129.948v5.426h-3.555V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
	</svg>
);

const Navigation = () => {
	const [location] = useLocation();
	const [hoveredItem, setHoveredItem] = useState(null);

	const navItems = [
		{ href: "/", label: "Home", icon: icon, category: "Home" },
		// Basic
		{ href: "/Accordions", label: "Accordions", icon: accordions, category: "Basic" },
		{ href: "/Badges", label: "Badges", icon: badge, category: "Basic" },
		{ href: "/Buttons", label: "Buttons", icon: buttons, category: "Basic" },
		{ href: "/Cards", label: "Cards", icon: card, category: "Basic" },
		// Display
		{ href: "/Carousels", label: "Carousels", icon: carousel, category: "Display" },
		{ href: "/Typography", label: "Typography", icon: fonts, category: "Display" },
		{ href: "/Footers", label: "Footers", icon: footers, category: "Display" },
		{ href: "/Images", label: "Images", icon: images, category: "Media" },
		{ href: "/Lists", label: "Lists", icon: lists, category: "Display" },
		// Feedback
		{ href: "/Modals", label: "Modals", icon: modals, category: "Feedback" },
		{ href: "/BannerAlert", label: "Banner Alert", icon: modals, category: "Feedback" },
		{ href: "/ConfirmationDialog", label: "Confirmation Dialog", icon: modals, category: "Feedback" },
		{ href: "/ErrorBoundary", label: "Error Boundary", icon: modals, category: "Feedback" },
		{ href: "/WarningCard", label: "Warning Card", icon: modals, category: "Feedback" },
		{ href: "/SuccessMessage", label: "Success Message", icon: modals, category: "Feedback" },
		{ href: "/LoadingState", label: "Loading State", icon: modals, category: "Feedback" },
		{ href: "/ToastStack", label: "Toast Stack", icon: modals, category: "Feedback" },
		{ href: "/HelpTooltip", label: "Help Tooltip", icon: modals, category: "Feedback" },
		// Forms
		{ href: "/InputField", label: "Input Field", icon: modals, category: "Forms" },
		{ href: "/SelectDropdown", label: "Select Dropdown", icon: modals, category: "Forms" },
		{ href: "/CheckboxGroup", label: "Checkbox Group", icon: modals, category: "Forms" },
		{ href: "/RadioButton", label: "Radio Button", icon: modals, category: "Forms" },
		{ href: "/TextArea", label: "Text Area", icon: modals, category: "Forms" },
		{ href: "/FormLabel", label: "Form Label", icon: modals, category: "Forms" },
		{ href: "/FormError", label: "Form Error", icon: modals, category: "Forms" },
		{ href: "/InputCounter", label: "Input Counter", icon: modals, category: "Forms" },
		// Navigation
		{ href: "/Breadcrumbs", label: "Breadcrumbs", icon: modals, category: "Navigation" },
		{ href: "/StickyHeader", label: "Sticky Header", icon: modals, category: "Navigation" },
		{ href: "/SideMenu", label: "Side Menu", icon: modals, category: "Navigation" },
		{ href: "/MobileMenu", label: "Mobile Menu", icon: modals, category: "Navigation" },
		{ href: "/ContextMenu", label: "Context Menu", icon: modals, category: "Navigation" },
		{ href: "/ScrollIndicator", label: "Scroll Indicator", icon: modals, category: "Navigation" },
		// Data
		{ href: "/DataTable", label: "Data Table", icon: modals, category: "Data" },
		{ href: "/ChartCard", label: "Chart Card", icon: modals, category: "Data" },
		{ href: "/StatBox", label: "Stat Box", icon: modals, category: "Data" },
		{ href: "/ProgressBar", label: "Progress Bar", icon: modals, category: "Data" },
		{ href: "/Timeline", label: "Timeline", icon: modals, category: "Data" },
		// Content
		{ href: "/BadgeLabel", label: "Badge Label", icon: modals, category: "Content" },
		{ href: "/CounterDisplay", label: "Counter Display", icon: modals, category: "Content" },
		{ href: "/BlockQuote", label: "Block Quote", icon: modals, category: "Content" },
		{ href: "/CodeBlock", label: "Code Block", icon: modals, category: "Content" },
		{ href: "/TextBlock", label: "Text Block", icon: modals, category: "Content" },
		{ href: "/MediaCaption", label: "Media Caption", icon: modals, category: "Content" },
		{ href: "/ArticlePreview", label: "Article Preview", icon: modals, category: "Content" },
		{ href: "/ContentCard", label: "Content Card", icon: modals, category: "Content" },
		// Overlay
		{ href: "/Sidebar", label: "Sidebar", icon: modals, category: "Overlay" },
		{ href: "/ModalDialog", label: "Modal Dialog", icon: modals, category: "Overlay" },
		{ href: "/DropdownMenu", label: "Dropdown Menu", icon: modals, category: "Overlay" },
		{ href: "/NotificationPanel", label: "Notification Panel", icon: modals, category: "Overlay" },
		{ href: "/FullscreenView", label: "Fullscreen View", icon: modals, category: "Overlay" },
		// Media
		{ href: "/ImageCard", label: "Image Card", icon: modals, category: "Media" },
		{ href: "/VideoPlayer", label: "Video Player", icon: modals, category: "Media" },
		{ href: "/GalleryModal", label: "Gallery Modal", icon: modals, category: "Media" },
		// Disclosure
		{ href: "/AccordionPanel", label: "Accordion Panel", icon: modals, category: "Disclosure" },
		{ href: "/TabPanel", label: "Tab Panel", icon: modals, category: "Disclosure" },
		// Layout
		{ href: "/CarouselWindow", label: "Carousel Window", icon: modals, category: "Layout" },
		// Interaction
		{ href: "/TooltipOverlay", label: "Tooltip Overlay", icon: modals, category: "Interaction" },
		// Commerce
		{ href: "/CartItem", label: "Cart Item", icon: modals, category: "Commerce" },
		{ href: "/CheckoutStep", label: "Checkout Step", icon: modals, category: "Commerce" },
		// Profile
		{ href: "/UserProfile", label: "User Profile", icon: modals, category: "Profile" },
	];

	const groupedItems = {
		Home: navItems.filter(i => i.category === "Home"),
		Basic: navItems.filter(i => i.category === "Basic"),
		Display: navItems.filter(i => i.category === "Display"),
		Feedback: navItems.filter(i => i.category === "Feedback"),
		Forms: navItems.filter(i => i.category === "Forms"),
		Navigation: navItems.filter(i => i.category === "Navigation"),
		Data: navItems.filter(i => i.category === "Data"),
		Content: navItems.filter(i => i.category === "Content"),
		Overlay: navItems.filter(i => i.category === "Overlay"),
		Media: navItems.filter(i => i.category === "Media"),
		Disclosure: navItems.filter(i => i.category === "Disclosure"),
		Layout: navItems.filter(i => i.category === "Layout"),
		Interaction: navItems.filter(i => i.category === "Interaction"),
		Commerce: navItems.filter(i => i.category === "Commerce"),
		Profile: navItems.filter(i => i.category === "Profile"),
	};

	return (
		<div className="bg-slate-950 h-screen lg:w-64 fixed overflow-y-scroll md:w-24 border-r border-slate-700 shadow-lg z-40 flex flex-col">
			{/* Logo Section */}
			<div className="p-4 mb-2 flex-shrink-0">
				<Link href="/">
					<div className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-800 transition-colors duration-250 cursor-pointer">
						<div
							className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-400 to-blue-500"
							style={{
								backgroundImage: `url("${icon}")`,
								backgroundSize: "cover",
							}}
						/>
						<span className="hidden lg:block font-bold text-amber-400 text-sm">Metatech</span>
					</div>
				</Link>
			</div>

			{/* Help Text */}
			<p className="hidden lg:block text-xs text-slate-500 px-7 mb-4 flex-shrink-0">
				Select a component to view examples
			</p>

			{/* Navigation Sections - Scrollable */}
			<nav className="space-y-4 flex-1 overflow-y-auto px-4">
				{Object.entries(groupedItems).map(([category, items]) => (
					<div key={category}>
						<p className="hidden lg:block text-xs font-semibold text-slate-500 px-3 mb-2 uppercase tracking-wide">
							{category}
						</p>
						<ul className="flex flex-col gap-1 lg:gap-2">
							{items.map((item) => {
								const isActive = location === item.href;
								return (
									<li key={item.href} className="relative">
										<Link href={item.href}>
											<div
												onMouseEnter={() => setHoveredItem(item.href)}
												onMouseLeave={() => setHoveredItem(null)}
												className={`
													flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-250
													${isActive 
														? "bg-gradient-to-r from-amber-500/20 to-amber-400/20 border border-amber-500/50 text-amber-400 font-semibold" 
														: "border border-transparent text-slate-400 hover:text-slate-200 hover:bg-slate-800/50"
													}
												`}
											>
												<img 
													src={item.icon} 
													alt="" 
													aria-hidden="true" 
													className={`w-5 h-5 transition-transform duration-250 ${
														hoveredItem === item.href ? "scale-110" : ""
													}`} 
												/>
												<span className="hidden lg:block text-sm">{item.label}</span>
											</div>
										</Link>
										{isActive && (
											<div className="hidden lg:block absolute -right-1 top-1/2 -translate-y-1/2 w-1 h-6 bg-gradient-to-b from-amber-400 to-blue-500 rounded-full" />
										)}
									</li>
								);
							})}
						</ul>
					</div>
				))}
			</nav>

			{/* Footer */}
			<div className="border-t border-slate-700 bg-slate-950 p-4 flex-shrink-0 space-y-3">
				<div className="hidden lg:flex justify-center gap-4">
					<a
						href="https://github.com/metatech-programmer"
						target="_blank"
						rel="noopener noreferrer"
						className="text-slate-500 hover:text-amber-400 transition-colors"
						title="GitHub"
						aria-label="GitHub"
					>
						<GitHubIcon />
					</a>
					
					<a
						href="https://www.linkedin.com/in/santiagoaguilartorres-fullstack/"
						target="_blank"
						rel="noopener noreferrer"
						className="text-slate-500 hover:text-amber-400 transition-colors"
						title="LinkedIn"
						aria-label="LinkedIn"
					>
						<LinkedInIcon />
					</a>
				</div>
				<a
					href="https://santiagotorres-web-developer.netlify.app/"
					target="_blank"
					rel="noopener noreferrer"
					className="text-xs text-slate-500 hover:text-amber-400 transition-colors text-center block"
				>
					By metatech - 2026
				</a>
			</div>
		</div>
	);
};

export default Navigation;


